export default [
  {
    path: '/',
    name: 'irpf',
    component: () => import('@/components/form/form-irpf.vue')
  }
]